import React from "react";
import { Link } from "react-router-dom"; // ZMIANA: useParams nie jest już potrzebny
import { categories } from "./coverData";
import "./App.css";

const CategorySelect: React.FC = () => {
  // ZMIANA: Usunęliśmy pobieranie i sprawdzanie pdfNameFromUrl

  return (
    <div className="selection-container">
      <h1>Wybierz kategorię okładki</h1>
      <p>Wybierz rodzaj projektu, który chcesz stworzyć.</p>
      
      <div className="grid-container">
        {categories.map((cat) => (
          <Link 
            key={cat.id} 
            // ZMIANA: Linkujemy do /kategoria/ID_KATEGORII (bez ID PDFa)
            to={`/kategoria/${cat.id}`} 
            className="card category-card"
            style={{ 
              display: 'flex', 
              flexDirection: 'column', 
              justifyContent: 'center', 
              alignItems: 'center',
              width: '200px',
              height: '150px',
              textDecoration: 'none',
              color: 'inherit'
            }}
          >
            <h3 style={{ margin: '0 0 10px 0' }}>{cat.title}</h3>
            <span style={{ color: '#666' }}>{cat.covers.length} wzorów</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CategorySelect;